// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "pay-260730-0/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","41":"a0ec33ed","777":"dfb468f1","788":"2ee88f8e","804":"51a6e114","810":"5b7541cc"}[chunkId] + ".chunk.js";
};